import { render, staticRenderFns } from "./image-video.vue?vue&type=template&id=3631674b&scoped=true&"
import script from "./image-video.vue?vue&type=script&lang=js&"
export * from "./image-video.vue?vue&type=script&lang=js&"
import style0 from "./image-video.vue?vue&type=style&index=0&id=3631674b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631674b",
  null
  
)

export default component.exports